/** Known values from product.packaging_types (IDs match the DB). */
export const PACKAGING_TYPES = [
	{ id: 1, name: "Box" },
	{ id: 2, name: "Poly mailer" },
	{ id: 3, name: "Poly bubble mailer" },
	{ id: 4, name: "Recycle bag" },
];

/** Options for selects, including unset (stores as 0). */
export const PACKAGING_TYPE_OPTIONS = [
	{ id: 0, name: "None" },
	...PACKAGING_TYPES,
];

export function getPackagingTypeLabel(id) {
	const numericId = Number(id);
	if (!numericId) {
		return "None";
	}
	const match = PACKAGING_TYPES.find((type) => type.id === numericId);
	return match ? match.name : `Unknown (${numericId})`;
}
